import { MatchStatus } from '@repo/types';

// Terminal states: the match has finished — at full time, after extra time, or
// decided on penalties. These all render as completed (not the live/in-progress
// state); a penalty/AET result is a final score, not a match still in progress.
const FINISHED_STATUSES: MatchStatus[] = [
  MatchStatus.FullTime,
  MatchStatus.FullTimeAfterExtraTime,
  MatchStatus.PenaltyShootOut,
];

export const isPastMatch = (status: MatchStatus) => {
  return FINISHED_STATUSES.includes(status);
};

export const isFutureMatch = (status: MatchStatus) => {
  return status === MatchStatus.NotKickedOff || status === MatchStatus.Postponed || status === MatchStatus.Abandoned;
};

export const isLiveMatch = (status: MatchStatus) => {
  return !isFutureMatch(status) && !isPastMatch(status);
};

export const parseMatchStatus = (status: MatchStatus) => {
  const isLive = !isFutureMatch(status) && !isPastMatch(status);

  return {
    isFutureMatch: isFutureMatch(status),
    isPastMatch: isPastMatch(status),
    isLiveMatch: isLive,
  };
};
